import Box from "@material-ui/core/Box"
import { Route } from "react-router"

export default function Achievements({ path }) {
  return (
    <Route path={`${path}`}>
      <Box>Achievements</Box>
    </Route>
  )
}
